import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestTwitterSettings } from '../../store/twitterSettings/twitterSettings.thunks';
import { requestSportStart } from '../../store/eventPage/eventPage.thunks';
import { requestOpenBets } from '../../store/openBets/openBets.thunks';
import { requestSportData, requestSportStats } from '../../store/sportEvent/sportEvent.thunks';
import { getSportEventError, getSportStatsError, getSportVisualisationError, getSportVideoError } from '../../store/sportEvent/sportEvent.slice';
// import { setHeaderHeight } from '../../store/elementsParams/elementsParams.slice'
import { headerHeightThunk } from '../../store/elementsParams/getElementsParams.thunk';
import { setRulesPopUp } from '../../store/rulesPopUp/rulesPopUp.slice';
import { setConfirmation, setMarket, setRunner, setIsBack, setPrice, setPriceActual, setStake, setDelay, setShowBetPlacingPopover, setBetPlacingPopoverStage } from '../../store/betPlacing/betPlacing.slice'

export const connectExchangeGamePage = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      lastActivityDate: state.balance.lastActivityDate,
      sportEventStats: state.sportEvent.sportStats,
      twitterSettings: state.twitterSettings,
      openBets: state.openBets,
      betPlacing: state.betPlacing,
      // exposure: state.eventPage.exposure,
      orders: state.eventPage.orders,
      sportData: state.sportEvent.sportData,
      // raceOdds: state.raceOdds,
      rulesPopUp: state.rulesPopUp,
      elementsParams: state.elementsParams
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestTwitterSettings,
      requestOpenBets,
      requestSportStart,
      requestSportData,
      requestSportStats,
      getSportEventError,
      getSportStatsError,
      getSportVideoError,
      getSportVisualisationError,
      headerHeightThunk,
      setRulesPopUp,
      setMarket,
      setRunner,
      setIsBack,
      setPrice,
      setPriceActual,
      setDelay,
      setStake,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
